
// @ts-nocheck
import locale__usr_src_app_client_locales_languages_kk_js from "../client/locales/languages/kk.js?hash=be4e076e&locale=kk";
import locale__usr_src_app_client_locales_languages_ru_js from "../client/locales/languages/ru.js?hash=e80d6b44&locale=ru";


export const localeCodes =  [
  "kk",
  "ru"
]

export const localeLoaders = {
  "kk": [{ key: "../client/locales/languages/kk.js", load: () => Promise.resolve(locale__usr_src_app_client_locales_languages_kk_js), cache: false }],
  "ru": [{ key: "../client/locales/languages/ru.js", load: () => Promise.resolve(locale__usr_src_app_client_locales_languages_ru_js), cache: false }]
}

export const vueI18nConfigs = [
  () => import("../client/locales/vue-i18n.js?hash=a6023a0e&config=1" /* webpackChunkName: "client_locales_vue_i18n_js_a6023a0e" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "client/locales/vue-i18n.js",
  "locales": [
    {
      "code": "kk",
      "iso": "kk-KZ",
      "dir": "ltr",
      "lang": "қазақша",
      "dayjsLocale": "kk",
      "name": "Казахстан",
      "country": "kz",
      "storeId": "kz",
      "languageCode": {
        "ru": "ru_RU",
        "kk": "ru_KZ"
      },
      "currencySymbol": "₸",
      "currencyCode": "KZT",
      "baseUrl": "https://goldapple.kz",
      "files": [
        "locales/languages/kk.js"
      ]
    },
    {
      "code": "ru",
      "iso": "ru-KZ",
      "dir": "ltr",
      "lang": "русский",
      "dayjsLocale": "ru",
      "name": "Казахстан",
      "country": "kz",
      "storeId": "kz",
      "languageCode": {
        "ru": "ru_RU",
        "kk": "ru_KZ"
      },
      "currencySymbol": "₸",
      "currencyCode": "KZT",
      "baseUrl": "https://goldapple.kz",
      "files": [
        "locales/languages/ru.js"
      ]
    }
  ],
  "defaultLocale": "ru",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": "locales/languages",
  "detectBrowserLanguage": {
    "alwaysRedirect": true,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "ga-lang",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "all",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://goldapple.kz",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": true,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "kk",
    "iso": "kk-KZ",
    "dir": "ltr",
    "lang": "қазақша",
    "dayjsLocale": "kk",
    "name": "Казахстан",
    "country": "kz",
    "storeId": "kz",
    "languageCode": {
      "ru": "ru_RU",
      "kk": "ru_KZ"
    },
    "currencySymbol": "₸",
    "currencyCode": "KZT",
    "baseUrl": "https://goldapple.kz",
    "files": [
      {
        "path": "locales/languages/kk.js"
      }
    ]
  },
  {
    "code": "ru",
    "iso": "ru-KZ",
    "dir": "ltr",
    "lang": "русский",
    "dayjsLocale": "ru",
    "name": "Казахстан",
    "country": "kz",
    "storeId": "kz",
    "languageCode": {
      "ru": "ru_RU",
      "kk": "ru_KZ"
    },
    "currencySymbol": "₸",
    "currencyCode": "KZT",
    "baseUrl": "https://goldapple.kz",
    "files": [
      {
        "path": "locales/languages/ru.js"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
